import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/depop-scams';

export default function Example() {
  return (
    <>
      <Head>
        <title>Sellers Beware: Depop Scams You Should Watch Out For</title>
        <meta name='description' content='Discover common scams encountered by Depop Sellers and how to avoid them!' />
        <link rel='canonical' href='https://tools.oneshop.com/blog/depop-scams' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/depop-scams' />
        <meta property='og:title' content='Sellers Beware: Depop Scams You Should Watch Out For' />
        <meta
          property='og:description'
          content='Discover common scams encountered by Depop Sellers and how to avoid them!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='April 8th, 2022' />
        <meta property='article:modified_time' content='April 8th, 2022' />
        <meta property='article:tag' content='Depop' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
